function removeNode(element: HTMLElement | null): void {
  if (element && element.parentElement) {
    element.parentElement.removeChild(element);
  }
}

export default removeNode;
